// @flow
import AxiosClient from '../AxiosClient';
import type { AxiosPromise } from 'axios';

export default class InvestorContactClient extends AxiosClient {
  create(params: Object): AxiosPromise<any> {
    return this.buildClient().post('/api/v1/investor_contacts', params);
  }
}
